import { render, staticRenderFns } from "./OGrupoGeneralComp.vue?vue&type=template&id=c211ceb4&"
import script from "./OGrupoGeneralComp.vue?vue&type=script&lang=js&"
export * from "./OGrupoGeneralComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports